import React from "react";
import NextImage from "./NextImage";
import { timeSince } from "../../utils/generalLiveCenter";
import { addSizeToImgUrl } from "../../utils/general";

export const Img = ({ slug, imgURL = "", altText, externalLink }) => {
  return (
    <div className="post_image">
      {slug ? (
        <a href={externalLink ? externalLink : "#"} target="_blank" rel="noreferrer">
          <NextImage
            src={addSizeToImgUrl(imgURL, 345)}
            fill
            alt={altText}
            objectFit={"cover"}
            width={400}
            height={300}
          />
        </a>
      ) : (
        <NextImage
          src={addSizeToImgUrl(imgURL, 345)}
          fill
          alt={altText}
          objectFit={"cover"}
          width={400}
          height={300}
        />
      )}
    </div>
  );
};
export const ImgSlug = ({ slug, imgURL = "", altText, externalLink }) => {
  return (
    <div className="post_image">
      {slug ? (
        <a href={externalLink ? externalLink : "#"}>
          <NextImage
            src={addSizeToImgUrl(imgURL, 345)}
            fill
            alt={altText}
            objectFit={"cover"}
            width={400}
            height={300}
          />
        </a>
      ) : (
        <NextImage
          src={addSizeToImgUrl(imgURL, 345)}
          fill
          alt={altText}
          objectFit={"cover"}
          width={400}
          height={300}
        />
      )}
    </div>
  );
};
export const Discription = ({ children }) => {
  return <div className="post_description">{children}</div>;
};

export const Author = ({
  authorName = "Anonymous",
  start_date,
  dictionary,
  showBy = true,
  showStartDate = false,
  slug,
}) => {
  return (
    <div className="post_author">
      {showBy && (dictionary?.by || "by")}
      {slug ? (
        <a href={`/author/${slug}`}>{authorName}</a>
      ) : (
        <strong>{authorName}</strong>
      )}
      {start_date && showStartDate && (
        <span className="post_date">{start_date}</span>
      )}
      {start_date && !showStartDate && (
        <span className="post_date">{timeSince(start_date, dictionary)}</span>
      )}
    </div>
  );
};

export const Title = ({ slug, children, lnk = true, externalLink }) => {
  return (
    <h3 className="post_title">
      {lnk ? (
        <a href={externalLink ? externalLink : "#"}>{children}</a>
      ) : (
        children
      )}
    </h3>
  );
};
export const TitleSlug = ({ slug, children, lnk = true, externalLink }) => {
  return (
    <h3 className="post_title">
      {lnk ? (
        <a href={externalLink ? externalLink : "#"} target="_blank" rel="noreferrer">
          {children}
        </a>
      ) : (
        children
      )}
    </h3>
  );
};
export const TitleBig = ({ children, lnk = true, externalLink, index = 1 }) => {
  const HeadingTag = index === 0 ? "h1" : "h2";

  return (
    <HeadingTag className="post_title_big">
      {lnk ? (
        <a href={externalLink ? externalLink : "#"}>{children}</a>
      ) : (
        children
      )}
    </HeadingTag>
  );
};
export const TitleBigSlug = ({
  children,
  lnk = true,
  externalLink,
  index = 1,
}) => {
  const HeadingTag = index === 0 ? "h1" : "h2";

  return (
    <HeadingTag className="post_title_big">
      {lnk ? (
        <a href={externalLink ? externalLink : "#"}>{children}</a>
      ) : (
        children
      )}
    </HeadingTag>
  );
};

export const TitleBig2 = ({ children }) => {
  return <h1 className="post_title_big">{children}</h1>;
};

export const TextDiscription = ({ children }) => {
  return (
    <div className="text_wrp">
      <p>{children}</p>
    </div>
  );
};
export const Tags = ({ subjects = [] }) => {
  return (
    <>
      {subjects && (
        <ul className="tag_lst">
          {subjects?.slice(0, 12)?.map((tag) => (
            <li key={tag.id}>{tag?.name}</li>
          ))}
        </ul>
      )}
    </>
  );
};
// export const Category = ({ categoryTitle }) => {
//   return (
//     <a className="badge" href={`/${titleToSlug(categoryTitle)}`}>
//       {categoryTitle}
//     </a>
//   );
// };

// export const Category2 = ({ categoryTitle }) => {
//   return (
//     <a className="badge2" href={`/${titleToSlug(categoryTitle)}`}>
//       {categoryTitle}
//     </a>
//   );
// };

const PostCard = ({ clas = "", children }) => {
  return <article className={`post_card ${clas}`}>{children}</article>;
};

PostCard.Img = Img;
PostCard.ImgSlug = ImgSlug;
PostCard.Discription = Discription;
PostCard.Title = Title;
PostCard.TitleSlug = TitleSlug;
PostCard.TitleBig = TitleBig;
PostCard.TitleBig2 = TitleBig2;
PostCard.TitleBigSlug = TitleBigSlug;
PostCard.TextDiscription = TextDiscription;
PostCard.Tags = Tags;
PostCard.Author = Author;
// PostCard.Category = Category;
// PostCard.Category2 = Category2;
export default PostCard;
